module.exports = __webpack_public_path__ + "static/media/Folks-Bold.64a8f044.ttf";